export default "__VITE_ASSET__ac0a5a39__"